import { E as Be, I as we, C as $e, S as Ie, c as l, a as ue, T as D, b as ye, A as ke, M as de, P as be } from "./Tick-CrI49bkm.js";
import { useMemo as ee, forwardRef as x, createContext as me, useContext as R, useState as P, useRef as A, useCallback as X, useEffect as F, isValidElement as Pe, cloneElement as Me } from "react";
import { j as e, S as W } from "./radix-common-Dx8bZddK.js";
import { V as qn } from "./radix-common-Dx8bZddK.js";
import { T as Y, a as q, b as Re, B as M, L as ze, c as Ee, d as he } from "./TabsList-H9VF_HUb.js";
import { A as Gn, v as Xn, e as Qn, j as Zn, l as Kn, i as eo, p as so, m as to, n as no, o as oo, k as ao, g as io, M as ro, h as co, f as lo, R as uo, q as bo, r as mo, S as ho, u as po, s as go, t as _o } from "./TabsList-H9VF_HUb.js";
import { A as Oe } from "./AsyncStateController-BiW_uEVt.js";
import { C as se, f as pe, g as ge } from "./radix-collapsible-CI9x1I_j.js";
import { u as I, T as U } from "./mergeRefs-CBC__vyO.js";
import { R as He, T as De, a as Ae, b as Fe, c as Le, C as _e, O as Ve, d as Je } from "./radix-dialog-hzmYIvwL.js";
import { R as We, T as Ye } from "./radix-switch-BWYjzRN2.js";
import { T as fo } from "./radix-tabs-DdOmeFzM.js";
import { P as qe, T as Ue, R as Ge, a as Xe, C as Qe, A as Ze } from "./radix-tooltip-u2B4Kdit.js";
import './components.css';const Ke = "sb-ui-container__uQbiG", es = "sb-ui-banner__epaT8", ss = "sb-ui-card__mYz6u", ts = "sb-ui-info__-J-F1", ns = "sb-ui-warning__uOpos", os = "sb-ui-error__ah9Kg", as = "sb-ui-success__lftZT", is = "sb-ui-icon__RUu7X", rs = "sb-ui-content__9Fty2", cs = "sb-ui-children__jJ2mn", ls = "sb-ui-actions__6On2P", S = {
  container: Ke,
  banner: es,
  card: ss,
  info: ts,
  warning: ns,
  error: os,
  success: as,
  icon: is,
  content: rs,
  children: cs,
  actions: ls
};
function bn({
  variant: s,
  title: t,
  actions: n,
  className: o,
  style: a,
  type: i = "card",
  children: c
}) {
  const r = ee(() => {
    switch (s) {
      case "success":
        return Ie;
      case "error":
        return $e;
      case "info":
        return we;
      case "warning":
        return Be;
    }
  }, [s]);
  return /* @__PURE__ */ e.jsxs("section", {
    className: l("sb-ui-alert", S.container, S[i], S[s], o),
    style: a,
    children: [/* @__PURE__ */ e.jsx(r, {
      className: l(S.icon),
      size: 20
    }), /* @__PURE__ */ e.jsx(Y, {
      asChild: !0,
      children: /* @__PURE__ */ e.jsxs("div", {
        className: S.content,
        children: [t && /* @__PURE__ */ e.jsx(q, {
          level: 5,
          children: t
        }), c && /* @__PURE__ */ e.jsx("div", {
          className: S.children,
          children: c
        })]
      })
    }), n && /* @__PURE__ */ e.jsx("div", {
      className: S.actions,
      children: n
    })]
  });
}
const us = "sb-ui-placeholder__JfR5r", ds = "sb-ui-state__YFhIn", bs = "sb-ui-rotate__yJ-4e", ms = "sb-ui-fadeIn__h0wh9", v = {
  placeholder: us,
  state: ds,
  rotate: bs,
  fadeIn: ms
};
function mn({
  children: s,
  state: t
}) {
  return /* @__PURE__ */ e.jsx(Oe, {
    state: t,
    loading: /* @__PURE__ */ e.jsxs(e.Fragment, {
      children: [/* @__PURE__ */ e.jsx("span", {
        className: v.placeholder,
        children: s
      }), /* @__PURE__ */ e.jsx("span", {
        className: v.state,
        children: /* @__PURE__ */ e.jsx(ye, {
          className: v.rotate
        })
      })]
    }),
    success: /* @__PURE__ */ e.jsxs(e.Fragment, {
      children: [/* @__PURE__ */ e.jsx("span", {
        className: v.placeholder,
        children: s
      }), /* @__PURE__ */ e.jsx("span", {
        className: v.state,
        children: /* @__PURE__ */ e.jsx(D, {
          className: v.fadeIn
        })
      })]
    }),
    error: /* @__PURE__ */ e.jsxs(e.Fragment, {
      children: [/* @__PURE__ */ e.jsx("span", {
        className: v.placeholder,
        children: s
      }), /* @__PURE__ */ e.jsx("span", {
        className: v.state,
        children: /* @__PURE__ */ e.jsx(ue, {
          className: v.fadeIn
        })
      })]
    }),
    children: s
  });
}
const hs = "sb-ui-base__ppJiU", ps = {
  base: hs
}, hn = /* @__PURE__ */ x(function({
  className: t,
  asChild: n = !1,
  ...o
}, a) {
  const i = n ? W : "button";
  return /* @__PURE__ */ e.jsx(i, {
    className: l("sb-ui-button-clean", ps.base, t),
    ref: a,
    type: "button",
    ...o
  });
}), gs = "sb-ui-container__85MFa", _s = "sb-ui-info__ZwObT", xs = "sb-ui-warning__4IHkk", fs = "sb-ui-error__pFywB", js = "sb-ui-success__DMnu3", ie = {
  container: gs,
  info: _s,
  warning: xs,
  error: fs,
  success: js
};
function pn({
  variant: s,
  children: t
}) {
  return /* @__PURE__ */ e.jsx(Y, {
    className: l("sb-ui-badge", ie.container, ie[s]),
    children: t
  });
}
const xe = /* @__PURE__ */ me(void 0), gn = () => {
  const s = R(xe);
  if (s === void 0)
    throw new Error("useCollapsibleState must be used within a Collapsible");
  return s;
}, _n = ({
  open: s,
  defaultOpen: t,
  onOpenChange: n,
  children: o,
  ...a
}) => {
  const [i, c] = I({
    prop: s,
    defaultProp: t ?? !1,
    onChange: n
  });
  return /* @__PURE__ */ e.jsx(xe.Provider, {
    value: i,
    children: /* @__PURE__ */ e.jsx(se, {
      ...a,
      open: i,
      onOpenChange: c,
      children: o
    })
  });
}, Cs = "sb-ui-overlay__yHNQ5", vs = "sb-ui-content__iaYOo", Ns = "sb-ui-header__EYeyd", Ts = "sb-ui-titleContainer__Ej2LX", Ss = "sb-ui-title__2kYFo", Bs = "sb-ui-subtitle__qRzA6", ws = "sb-ui-closeBtn__WvHch", $s = "sb-ui-main__0VuJe", Is = "sb-ui-padding__SWP9S", ys = "sb-ui-footer__zieGq", j = {
  overlay: Cs,
  content: vs,
  header: Ns,
  titleContainer: Ts,
  title: Ss,
  subtitle: Bs,
  closeBtn: ws,
  main: $s,
  padding: Is,
  footer: ys
}, xn = He, fn = De, jn = Ae, ks = Fe, Ps = Le, Cn = _e, vn = /* @__PURE__ */ x(function(t, n) {
  return /* @__PURE__ */ e.jsx(Ve, {
    ...t,
    ref: n,
    className: l(t.className, j.overlay)
  });
}), Ms = (s) => {
  s.preventDefault();
}, Nn = /* @__PURE__ */ x(function({
  onOpenAutoFocus: t,
  className: n,
  ...o
}, a) {
  return /* @__PURE__ */ e.jsx(U.Provider, {
    value: "dark",
    children: /* @__PURE__ */ e.jsx(Re, {
      asChild: !0,
      children: /* @__PURE__ */ e.jsx(Je, {
        ...o,
        ref: a,
        onOpenAutoFocus: t ?? Ms,
        className: l(n, j.content)
      })
    })
  });
}), Tn = /* @__PURE__ */ x(function({
  title: t,
  subtitle: n,
  className: o,
  ...a
}, i) {
  return /* @__PURE__ */ e.jsxs("header", {
    ...a,
    ref: i,
    className: l(o, j.header),
    children: [/* @__PURE__ */ e.jsxs("div", {
      className: l(j.titleContainer),
      children: [/* @__PURE__ */ e.jsx(ks, {
        className: j.title,
        asChild: !0,
        children: /* @__PURE__ */ e.jsx(q, {
          level: 2,
          children: t
        })
      }), n != null && /* @__PURE__ */ e.jsx(Ps, {
        asChild: !0,
        children: /* @__PURE__ */ e.jsx("small", {
          className: j.subtitle,
          children: n
        })
      })]
    }), /* @__PURE__ */ e.jsx(_e, {
      asChild: !0,
      children: /* @__PURE__ */ e.jsx(M, {
        variant: "ghost",
        size: "icon",
        className: j.closeBtn,
        children: /* @__PURE__ */ e.jsx(ue, {
          size: 12
        })
      })
    })]
  });
}), Sn = /* @__PURE__ */ x(function({
  className: t,
  padding: n = !0,
  ...o
}, a) {
  return /* @__PURE__ */ e.jsx("section", {
    ref: a,
    ...o,
    className: l(t, j.main, n && j.padding)
  });
}), Bn = /* @__PURE__ */ x(function({
  className: t,
  ...n
}, o) {
  return /* @__PURE__ */ e.jsx("footer", {
    ...n,
    ref: o,
    className: l(t, j.footer)
  });
}), Rs = "sb-ui-arrow__Wgv4M", zs = {
  arrow: Rs
}, wn = /* @__PURE__ */ x(function({
  className: t,
  children: n,
  ...o
}, a) {
  return /* @__PURE__ */ e.jsxs(ze, {
    className: l("sb-ui-list-item-link", t),
    ref: a,
    type: "button",
    ...o,
    children: [n, /* @__PURE__ */ e.jsx(ke, {
      className: zs.arrow,
      size: 10
    })]
  });
}), Q = 0, Z = 1, L = 2, V = 3, J = 4, Es = 5, fe = 6, Os = ["preEnter", "entering", "entered", "preExit", "exiting", "exited", "unmounted"], je = (s) => ({
  _s: s,
  status: Os[s],
  isEnter: s < V,
  isMounted: s !== fe,
  isResolved: s === L || s > J
}), K = (s) => s ? fe : Es, Hs = (s, t) => {
  switch (s) {
    case Z:
    case Q:
      return L;
    case J:
    case V:
      return K(t);
  }
}, Ds = (s) => typeof s == "object" ? [s.enter, s.exit] : [s, s], As = (s, t) => setTimeout(() => {
  isNaN(document.body.offsetTop) || s(t + 1);
}, 0), re = (s, t, n, o, a) => {
  clearTimeout(o.current);
  const i = je(s);
  t(i), n.current = i, a && a({
    current: i
  });
}, Fs = ({
  enter: s = !0,
  exit: t = !0,
  preEnter: n,
  preExit: o,
  timeout: a,
  initialEntered: i,
  mountOnEnter: c,
  unmountOnExit: r,
  onStateChange: u
} = {}) => {
  const [b, d] = P(() => je(i ? L : K(c))), h = A(b), f = A(), [T, y] = Ds(a), B = X(() => {
    const N = Hs(h.current._s, r);
    N && re(N, d, h, f, u);
  }, [u, r]), z = X((N) => {
    const p = (C) => {
      switch (re(C, d, h, f, u), C) {
        case Z:
          T >= 0 && (f.current = setTimeout(B, T));
          break;
        case J:
          y >= 0 && (f.current = setTimeout(B, y));
          break;
        case Q:
        case V:
          f.current = As(p, C);
          break;
      }
    }, w = h.current.isEnter;
    typeof N != "boolean" && (N = !w), N ? !w && p(s ? n ? Q : Z : L) : w && p(t ? o ? V : J : K(r));
  }, [B, u, s, t, n, o, T, y, r]);
  return [b, z, B];
};
function Ls(s) {
  const t = A(null), [n, o] = P(0), [a, i] = P(0), c = (r) => {
    let u = 0, b = 0;
    for (let d = 0; d < r.length; d++) {
      const f = r[d].getBoundingClientRect().height;
      u += d < s ? f : 0, b += f;
    }
    o(u), i(b);
  };
  return F(() => {
    var r;
    t.current && c((r = t.current) == null ? void 0 : r.children);
  }), {
    ref: t,
    totalHeight: a,
    collapsedHeight: n
  };
}
const Vs = "sb-ui-trigger__tQZe3", Js = "sb-ui-list__TmFcM", ce = {
  trigger: Vs,
  list: Js
}, Ws = (s) => {
  const [t, n] = P(!1);
  return F(() => {
    const o = new IntersectionObserver(([a]) => n(a.isIntersecting));
    return s.current && o.observe(s.current), () => {
      o.disconnect();
    };
  }, [s]), t;
}, $n = ({
  children: s,
  collapsedLimit: t,
  forceMount: n,
  className: o,
  showLessText: a = "Show less",
  showMoreText: i = "Show more",
  open: c,
  defaultOpen: r,
  onOpenChange: u,
  disabled: b,
  ...d
}) => {
  const [h, f] = I({
    prop: c,
    defaultProp: r ?? !1,
    onChange: u
  }), T = A(null), y = Ws(T), {
    ref: B,
    totalHeight: z,
    collapsedHeight: N
  } = Ls(t), [{
    status: p
  }, w] = Fs({
    timeout: 200,
    mountOnEnter: !0,
    preEnter: !0
  }), [C, Ne] = P(!0), te = X(() => {
    setTimeout(() => {
      p === "unmounted" && C && Ne(!1);
    }, 100);
  }, [p, C]);
  F(te, [te]), F(() => {
    w(h);
  }, [w, h]);
  const Te = () => {
    var $;
    f((ne) => !ne), h && !y && (($ = T.current) == null || $.scrollIntoView({
      behavior: "smooth",
      block: "center"
    }));
  }, Se = ee(() => {
    const $ = p === "preEnter", oe = p === "entering" || p === "entered" || p === "exiting";
    return s.map((k, G) => {
      if (G >= t && !$ && !oe && !n)
        return;
      const ae = {
        display: G < t || $ || oe ? void 0 : "none",
        opacity: G >= t && !C && ($ || p === "exiting") ? 0 : 1,
        transition: "opacity 0.2s ease-in-out"
      };
      return /* @__PURE__ */ Pe(k) ? /* @__PURE__ */ Me(k, {
        className: l("sb-ui-expandable-list-item", k.props.className),
        style: {
          ...k.props.style,
          ...ae
        }
      }) : /* @__PURE__ */ e.jsx("li", {
        className: "sb-ui-expandable-list-item",
        style: ae,
        children: k
      });
    });
  }, [s, n, t, C, p]);
  return /* @__PURE__ */ e.jsxs("div", {
    className: l("sb-ui-expandable-list", o),
    ...d,
    children: [/* @__PURE__ */ e.jsx("div", {
      ref: T
    }), /* @__PURE__ */ e.jsx(Ee, {
      className: ce.list,
      style: {
        height: h && p !== "exiting" ? z : N,
        transition: C ? "none" : "height 0.2s ease-in-out"
      },
      ref: B,
      children: Se
    }), s.length > t && z > 0 && /* @__PURE__ */ e.jsx(M, {
      variant: "link",
      size: "medium",
      className: ce.trigger,
      onClick: Te,
      disabled: b,
      children: h ? a : i
    })]
  });
}, Ys = "sb-ui-modalBannerContainer__CM-QP", qs = "sb-ui-modalBanner__YZzCe", Us = "sb-ui-modalBannerIcon__d4MW2", Gs = "sb-ui-modalBannerTitle__qX0Cn", E = {
  modalBannerContainer: Ys,
  modalBanner: qs,
  modalBannerIcon: Us,
  modalBannerTitle: Gs
};
function In({
  icon: s,
  title: t,
  className: n,
  children: o,
  ...a
}) {
  return /* @__PURE__ */ e.jsx("section", {
    ...a,
    className: l(n, E.modalBannerContainer),
    children: /* @__PURE__ */ e.jsxs("div", {
      className: E.modalBanner,
      children: [/* @__PURE__ */ e.jsx("div", {
        className: E.modalBannerIcon,
        children: s
      }), /* @__PURE__ */ e.jsxs("div", {
        children: [/* @__PURE__ */ e.jsx(q, {
          level: 4,
          className: E.modalBannerTitle,
          children: t
        }), o]
      })]
    })
  });
}
const Xs = "sb-ui-base__BoO9r", Qs = "sb-ui-medium__I69CW", Zs = "sb-ui-large__zsQOe", Ks = "sb-ui-yellow__NWVn5", et = "sb-ui-green__AV-so", st = "sb-ui-group__-oh4o", tt = "sb-ui-placeholder__t-q9j", nt = "sb-ui-light__2FP1H", ot = "sb-ui-dark__X3i4F", m = {
  base: Xs,
  medium: Qs,
  large: Zs,
  default: "sb-ui-default__LcVkW",
  yellow: Ks,
  green: et,
  group: st,
  placeholder: tt,
  light: nt,
  dark: ot
}, at = he({
  base: m.base,
  variants: {
    size: {
      medium: m.medium,
      large: m.large
    },
    theme: {
      dark: m.dark,
      light: m.light
    },
    color: {
      default: m.default,
      yellow: m.yellow,
      green: m.green
    }
  },
  defaultVariants: {
    color: "default",
    size: "medium",
    theme: "dark"
  }
}), it = he({
  base: l(m.base, m.placeholder),
  variants: {
    size: {
      medium: m.medium,
      large: m.large
    },
    theme: {
      dark: m.dark,
      light: m.light
    }
  },
  defaultVariants: {
    size: "medium",
    theme: "dark"
  }
}), yn = /* @__PURE__ */ x(function({
  className: t,
  theme: n,
  size: o,
  selected: a,
  asChild: i = !1,
  color: c,
  ...r
}, u) {
  const b = i ? W : "button", d = R(U);
  return /* @__PURE__ */ e.jsx(b, {
    className: l("sb-ui-price-button", at({
      color: c,
      size: o,
      theme: n ?? d
    }), t),
    ref: u,
    type: "button",
    "data-selected": a,
    ...r
  });
});
function kn({
  children: s,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ e.jsx("div", {
    className: l(m.group, t),
    ...n,
    children: s
  });
}
function Pn({
  asChild: s,
  size: t,
  theme: n,
  className: o,
  ...a
}) {
  const i = s ? W : "div", c = R(U);
  return /* @__PURE__ */ e.jsx(i, {
    className: l("sb-ui-price-button-placeholder", it({
      size: t,
      theme: n ?? c
    }), o),
    ...a
  });
}
const rt = "sb-ui-container__-D-Uu", ct = {
  container: rt
}, Mn = ({
  children: s,
  className: t,
  ...n
}) => /* @__PURE__ */ e.jsx(Y, {
  className: l("sb-ui-promo-pill", ct.container, t),
  ...n,
  children: s
}), lt = "sb-ui-container__Jdyll", ut = "sb-ui-verticalCenter__mfRuT", dt = "sb-ui-bottomBorder__3Mt9I", bt = "sb-ui-content__coioY", mt = "sb-ui-title__BGXFT", ht = "sb-ui-icons__6w0-U", pt = "sb-ui-h1__81W0T", gt = "sb-ui-h2__EJYFR", _t = "sb-ui-h3__P8joI", xt = "sb-ui-h4__gxzr-", ft = "sb-ui-h5__ZmgYM", jt = "sb-ui-h6__i-BoS", Ct = "sb-ui-actions__-0sNY", vt = "sb-ui-head__XSwSz", Nt = "sb-ui-dark__9uUG-", Tt = "sb-ui-light__WH36c", St = "sb-ui-info__MucKg", g = {
  container: lt,
  verticalCenter: ut,
  bottomBorder: dt,
  content: bt,
  title: mt,
  icons: ht,
  h1: pt,
  h2: gt,
  h3: _t,
  h4: xt,
  h5: ft,
  h6: jt,
  actions: Ct,
  head: vt,
  dark: Nt,
  light: Tt,
  info: St
};
function Bt({
  children: s,
  level: t = 3,
  bold: n = !0,
  verticalCenter: o = !1,
  icons: a,
  actions: i,
  head: c,
  info: r,
  bottomBorder: u = !0,
  className: b
}) {
  const d = R(U);
  return /* @__PURE__ */ e.jsxs("div", {
    className: l("sb-ui-section-title", g.container, g[`h${t}`], g[d ?? "dark"], o && g.verticalCenter, u && g.bottomBorder, b),
    "data-test-id": "sb-ui-section-title",
    children: [/* @__PURE__ */ e.jsxs("div", {
      className: g.content,
      children: [c && /* @__PURE__ */ e.jsx("div", {
        className: g.head,
        children: c
      }), /* @__PURE__ */ e.jsxs("div", {
        className: g.title,
        children: [a && /* @__PURE__ */ e.jsx("div", {
          className: g.icons,
          children: a
        }), /* @__PURE__ */ e.jsx(q, {
          bold: n,
          level: t,
          children: s
        })]
      }), r && /* @__PURE__ */ e.jsx("div", {
        className: g.info,
        children: r
      })]
    }), i && /* @__PURE__ */ e.jsx("div", {
      className: g.actions,
      children: i
    })]
  });
}
const wt = "sb-ui-trigger__fCvsJ", $t = "sb-ui-triggerIcon__r-7p6", It = "sb-ui-actions__JHSWd", O = {
  trigger: wt,
  triggerIcon: $t,
  actions: It
}, Ce = /* @__PURE__ */ me(!1);
function Rn({
  children: s,
  open: t,
  onOpenChange: n,
  defaultOpen: o = !0,
  className: a,
  ...i
}) {
  const [c, r] = I({
    prop: t,
    defaultProp: o ?? !1,
    onChange: n
  });
  return /* @__PURE__ */ e.jsx(Ce.Provider, {
    value: c ?? !1,
    children: /* @__PURE__ */ e.jsx(se, {
      ...i,
      onOpenChange: r,
      open: c ?? !1,
      className: l("sb-ui-collapsible-section", a),
      asChild: !0,
      children: /* @__PURE__ */ e.jsx("section", {
        children: s
      })
    })
  });
}
function zn({
  actions: s,
  children: t,
  triggerSize: n = 22,
  disabled: o,
  ...a
}) {
  const i = R(Ce);
  return /* @__PURE__ */ e.jsx(ge, {
    disabled: o,
    className: O.trigger,
    children: /* @__PURE__ */ e.jsx(Bt, {
      ...a,
      actions: /* @__PURE__ */ e.jsxs(e.Fragment, {
        children: [s != null && /* @__PURE__ */ e.jsx("div", {
          className: O.actions,
          onClick: (c) => c.stopPropagation(),
          children: s
        }), i ? /* @__PURE__ */ e.jsx(de, {
          size: n,
          className: O.triggerIcon
        }) : /* @__PURE__ */ e.jsx(be, {
          size: n,
          className: O.triggerIcon
        })]
      }),
      children: t
    })
  });
}
const En = pe, yt = "sb-ui-trigger__sL-JA", kt = {
  trigger: yt
};
function On({
  children: s,
  open: t,
  onOpenChange: n,
  defaultOpen: o = !1,
  className: a,
  showLessText: i = "Show less",
  showMoreText: c = "Show more",
  ...r
}) {
  const [u, b] = I({
    prop: t,
    defaultProp: o ?? !1,
    onChange: n
  });
  return /* @__PURE__ */ e.jsxs(se, {
    ...r,
    onOpenChange: b,
    open: u ?? !1,
    className: l("sb-ui-expandable-section", a),
    children: [/* @__PURE__ */ e.jsx("section", {
      children: s
    }), /* @__PURE__ */ e.jsx(ge, {
      asChild: !0,
      children: /* @__PURE__ */ e.jsx(M, {
        variant: "link",
        size: "medium",
        className: kt.trigger,
        children: u ? i : c
      })
    })]
  });
}
const Hn = pe, Pt = "sb-ui-container__-bB8T", Mt = {
  container: Pt
};
function Dn({
  asChild: s,
  className: t,
  ...n
}) {
  const o = s ? W : "header";
  return /* @__PURE__ */ e.jsx(o, {
    ...n,
    className: l("sb-ui-section-sub-header", Mt.container, t)
  });
}
const Rt = "sb-ui-container__p4Zkl", zt = "sb-ui-controlBtn__tu5mR", Et = "sb-ui-label__vURqT", H = {
  container: Rt,
  controlBtn: zt,
  label: Et
};
function An(s) {
  const [t, n] = I({
    prop: s.value,
    onChange: s.onChange,
    defaultProp: s.defaultValue
  }), [o, a, i, c] = ee(() => {
    if (t == null)
      return [s.placeholder, null, s.options.length > 0 ? 0 : null, -1];
    const r = s.options.findIndex((u) => u.value === t);
    return r === -1 ? [s.placeholder, null, s.options.length > 0 ? 0 : null, -1] : [s.options[r].label, r > 0 ? r - 1 : null, r < s.options.length - 1 ? r + 1 : null, r];
  }, [t, s.options, s.placeholder]);
  return /* @__PURE__ */ e.jsxs("div", {
    className: l("sb-ui-stepper", H.container, s.className),
    children: [/* @__PURE__ */ e.jsx(M, {
      variant: "link",
      size: "icon",
      className: H.controlBtn,
      disabled: t == null || a == null && s.required,
      onClick: () => {
        a != null ? n(s.options[a].value) : !s.required && c === 0 && n(null);
      },
      children: /* @__PURE__ */ e.jsx(de, {
        size: 15
      })
    }), /* @__PURE__ */ e.jsx(Y, {
      variant: "bodyPrimary",
      className: H.label,
      children: o
    }), /* @__PURE__ */ e.jsx(M, {
      variant: "link",
      size: "icon",
      className: H.controlBtn,
      disabled: i == null,
      onClick: () => i != null && n(s.options[i].value),
      children: /* @__PURE__ */ e.jsx(be, {
        size: 15
      })
    })]
  });
}
const Ot = "sb-ui-root__DmzxH", Ht = "sb-ui-thumb__utQqb", le = {
  root: Ot,
  thumb: Ht
}, Fn = /* @__PURE__ */ x(function({
  className: t,
  ...n
}, o) {
  return /* @__PURE__ */ e.jsx(We, {
    ...n,
    ref: o,
    className: l("sb-ui-switch", le.root, t),
    children: /* @__PURE__ */ e.jsx(Ye, {
      className: le.thumb
    })
  });
}), Dt = "sb-ui-TooltipContent__wLEZU", At = "sb-ui-TooltipArrow__h3J9a", ve = {
  TooltipContent: Dt,
  TooltipArrow: At
}, Ln = qe, Ft = Ue, Lt = Ge, Vt = Xe, Jt = /* @__PURE__ */ x(function({
  className: t,
  ...n
}, o) {
  return /* @__PURE__ */ e.jsx(Qe, {
    ...n,
    ref: o,
    className: l(ve.TooltipContent, t)
  });
}), Wt = /* @__PURE__ */ x(function({
  className: t,
  ...n
}, o) {
  return /* @__PURE__ */ e.jsx(Ze, {
    ...n,
    ref: o,
    className: l(ve.TooltipArrow, t)
  });
});
function Vn({
  open: s,
  defaultOpen: t,
  onOpenChange: n,
  children: o,
  content: a,
  className: i,
  sideOffset: c,
  onClick: r,
  ...u
}) {
  const [b, d] = I({
    prop: s,
    defaultProp: t,
    onChange: n
  });
  return /* @__PURE__ */ e.jsxs(Lt, {
    open: b,
    onOpenChange: d,
    children: [/* @__PURE__ */ e.jsx(Ft, {
      asChild: !0,
      children: o
    }), /* @__PURE__ */ e.jsx(Vt, {
      children: /* @__PURE__ */ e.jsxs(Jt, {
        ...u,
        sideOffset: c ?? 5,
        className: l("sb-ui-tooltip-content", i),
        onClick: (h) => {
          r != null ? r(h) : d(!1);
        },
        tabIndex: 0,
        role: "button",
        children: [a, /* @__PURE__ */ e.jsx(Wt, {})]
      })
    })]
  });
}
const Yt = "sb-ui-progressBarContainer__u9RQl", qt = "sb-ui-progressBar__Sepd5", Ut = "sb-ui-progressStepsContainer__o5a5B", Gt = "sb-ui-stepContainer__elnG-", Xt = "sb-ui-step__aBskS", Qt = "sb-ui-activeStep__fClYG", Zt = "sb-ui-inactiveStep__SwMB5", Kt = "sb-ui-horizontalLine__jeI2J", en = "sb-ui-inactiveHorizontalLine__qjj-4", _ = {
  progressBarContainer: Yt,
  progressBar: qt,
  progressStepsContainer: Ut,
  stepContainer: Gt,
  step: Xt,
  activeStep: Qt,
  inactiveStep: Zt,
  horizontalLine: Kt,
  inactiveHorizontalLine: en
};
function Jn({
  variant: s = "bar",
  max: t,
  value: n,
  className: o,
  style: a
}) {
  const i = Math.max(1, t), c = Math.max(0, Math.min(n, i));
  if (s === "bar") {
    const r = `${100 * c / i}%`;
    return /* @__PURE__ */ e.jsx("div", {
      className: l("sb-ui-progress", _.progressBarContainer, o),
      style: a,
      children: /* @__PURE__ */ e.jsx("div", {
        className: _.progressBar,
        style: {
          width: r
        }
      })
    });
  }
  return /* @__PURE__ */ e.jsx("div", {
    className: l("sb-ui-progress", _.progressStepsContainer, o),
    style: a,
    children: Array.from({
      length: i
    }).map((r, u) => /* @__PURE__ */ e.jsxs("div", {
      className: _.stepContainer,
      children: [u < c && /* @__PURE__ */ e.jsx("div", {
        className: l(_.step),
        children: /* @__PURE__ */ e.jsx(D, {
          size: 6
        })
      }), u === c && /* @__PURE__ */ e.jsx("div", {
        className: l(_.step, _.activeStep),
        children: /* @__PURE__ */ e.jsx(D, {
          size: 6,
          style: {
            visibility: "hidden"
          }
        })
      }), u > c && /* @__PURE__ */ e.jsx("div", {
        className: l(_.step, _.inactiveStep),
        children: /* @__PURE__ */ e.jsx(D, {
          size: 6,
          style: {
            visibility: "hidden"
          }
        })
      }), u !== i - 1 && /* @__PURE__ */ e.jsx("div", {
        className: l(_.horizontalLine, u >= c && _.inactiveHorizontalLine)
      })]
    }))
  });
}
export {
  bn as Alert,
  Gn as Anchor,
  pn as Badge,
  Mn as BetOfferPill,
  M as Button,
  mn as ButtonAsyncStateController,
  hn as ButtonClean,
  _n as Collapsible,
  pe as CollapsibleContent,
  En as CollapsibleSectionContent,
  Rn as CollapsibleSectionRoot,
  Ce as CollapsibleSectionStateContext,
  zn as CollapsibleSectionTitle,
  ge as CollapsibleTrigger,
  Cn as DialogClose,
  Nn as DialogContent,
  Ps as DialogDescription,
  Bn as DialogFooter,
  Tn as DialogHeader,
  Sn as DialogMain,
  vn as DialogOverlay,
  jn as DialogPortal,
  xn as DialogRoot,
  ks as DialogTitle,
  fn as DialogTrigger,
  $n as ExpandableList,
  Hn as ExpandableSectionContent,
  On as ExpandableSectionRoot,
  Xn as LineClamp,
  Ee as List,
  Qn as ListItem,
  ze as ListItemButton,
  wn as ListItemLink,
  In as ModalBanner,
  Zn as ModalClose,
  Kn as ModalContent,
  eo as ModalDescription,
  so as ModalFooter,
  to as ModalHeader,
  no as ModalMain,
  oo as ModalMainContent,
  ao as ModalOverlay,
  io as ModalPortal,
  ro as ModalRoot,
  co as ModalTitle,
  lo as ModalTrigger,
  yn as PriceButton,
  kn as PriceButtonGroup,
  Pn as PriceButtonPlaceholder,
  Jn as Progress,
  uo as Result,
  Dn as SectionSubHeader,
  Bt as SectionTitle,
  bo as Separator,
  mo as Skeleton,
  An as Stepper,
  ho as Sticky,
  Fn as Switch,
  fo as TabsContent,
  po as TabsList,
  go as TabsRoot,
  _o as TabsTrigger,
  Y as Text,
  q as Title,
  Vn as Tooltip,
  Wt as TooltipArrow,
  Jt as TooltipContent,
  Vt as TooltipPortal,
  Ln as TooltipProvider,
  Lt as TooltipRoot,
  Ft as TooltipTrigger,
  Re as Typography,
  qn as VisuallyHidden,
  gn as useCollapsibleState
};
//# sourceMappingURL=components.js.map
